var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',{staticClass:"h-screen w-screen",attrs:{"id":"app"}},[_c('router-view'),_c('footer-app'),_c('plan-upgrade-host'),_c('legal-acceptance-modal')],1)}
var staticRenderFns = []

export { render, staticRenderFns }